import React, { useState } from 'react'
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { createStructuredSelector } from 'reselect';
import { showPopup } from '../../Containers/App/action';
import { selectProfile } from '../../Containers/Client/selector';
import { updateUserProfile } from '../../Pages/Settings/action';
import { handleUploadFile } from '../../Utils/uploadHelper';
import AddFileButton from '../Button/AddFileButton'
import ProfilePicture from '../ProfilePicture';
import styles from './style.module.scss';

function EditProfilePicture({profile}) {
  const [isOrigin, setIsOrigin] = useState(true);
  const [uploadedFile, setUploadedFile] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onUploadFile = async(e) => {
    const newFile = await handleUploadFile(e);
    setIsOrigin(false);
    setUploadedFile(newFile);
  }
  const onUpdateSuccess = () => {
    toast.success('Profile Picture Updated!');
    dispatch(showPopup({isOpen: false}));
    navigate('/');
  }
  const onClickSave = () => {
    dispatch(updateUserProfile({profilePicture: uploadedFile[0].base64}, onUpdateSuccess));
  };
  return (
    <div className={styles.container}>
      <h3>Change Profile Picture</h3>
      <div>
        <div className={styles.content}>
          <ProfilePicture url={isOrigin? profile.profilePicture: uploadedFile[0].blob}/>
        </div>
        <div className={styles.inputBtn}>
          <input
            type="file"
            accept="image/*"
            multiple
            style={{ display: 'none' }}
            id="contained-button-file-profile"
            onChange={onUploadFile}
            className={styles.inputField}
          />
          <label htmlFor="contained-button-file-profile">
            <AddFileButton /> 
          </label>
        </div>
      </div>
      <div className={styles.btnContainer}>
        <div className={styles.saveBtn} onClick={onClickSave}>
          Save Change
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  profile: selectProfile
})

export default connect(mapStateToProps)(EditProfilePicture)